import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { useEffect, useMemo, useState, useRef, useCallback } from 'react';
import { updatePageStatus } from 'redux/actions/ui.action';
import {
  getDetailSession,
  getSeniorDetailSession,
  getSeniorBuddyDetailSession,
  getDetailTopic,
  removeSession,
  trackingSession,
  buddyAcceptOrRejectSession,
  getListBuddyRole,
  verifyJoinSession,
  getProfileRoleBySession,
  reportData,
  getReasonReport,
} from 'redux/actions/mvp/session.action';
import './detail.scss';
import videoTime from 'static/images/mvp/video-time.png';
import topicLanguage from 'static/svg/topic-language.svg';
import timer from 'static/images/mvp/timer.png';
import otherRegisteredImg from 'static/images/mvp/other-registered.png';
import moment from 'moment/moment';
import { Modal as ModalPopup, ModalHeader } from 'react-bootstrap';
import removeSessionImage from '../../../../static/images/mvp/remove-session.png';
import sessionTimeImage from '../../../../static/images/mvp/session-time.png';
import phone from '../../../../static/svg/phone.svg';
import tablet from '../../../../static/svg/tablet.svg';
import laptop from '../../../../static/svg/laptop.svg';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '@zoom/videosdk-ui-toolkit/dist/videosdk-ui-toolkit.css';
import { I18n } from '../../../../helpers/i18n';
import { isMvpUserGuide } from '../../../../helpers/mvpAuth';
import CustomAccountLogo from '../../../components/core/CustomAccontLogo';
import { evaluateJoinEligibility } from './meeting-join/sessionJoinRules';
import {
  formatSessionDay,
  formatSessionDateTimeWithDay,
  formatSessionClockWithDate,
  formatSessionClockRange,
  formatSessionDate,
  formatSessionDateDashed,
} from './helper';
import report from '../../../../static/images/mvp/report.png';
import warning from '../../../../static/images/mvp/warning.png';
import { isTopicGuideOnBreak } from '../../../../helpers/guideStatus';
import RatingPromoteBanner from '../../../components/core/RatingPromoteBanner';
import UsersRatingListModal from '../../../components/core/UsersRatingListModal';
import TopicRatingListModal from '../../../components/core/TopicRatingListModal';
import TotalRatingsComponent from '../../../components/core/TotalRatingsComponent';
import CompactRatingDisplay from '../../../components/core/CompactRatingDisplay';
import RatingStarsDisplay from '../../../components/core/RatingStarsDisplay';
import RatingListItem from '../../../components/core/RatingListItem';
import { formatRating, maskUserName, getAgeAndBirthYear } from '../../../../helpers/utils';
import starActive from '../../../../static/images/mvp/star_active.png';
import '../../../components/core/RatingListModal.css';
import AiSupportSessionVideo from './ai-support-session-video';
import KambriaMeetingDownloadModal from './meeting-join/KambriaMeetingDownloadModal';

const RATING_STAR_LABEL_KEYS = ['ratting_one', 'ratting_two', 'ratting_three', 'ratting_four', 'ratting_five'];
const REVIEW_SUPPORT_EMAIL = 'ced@kambria.io';

function reviewReasonKey(code) {
  const known = ['SPAM', 'ABUSIVE', 'PERSONAL_INFO', 'IRRELEVANT', 'NOT_GENUINE', 'OTHER'];
  return known.indexOf(code) >= 0 ? `review_reason_${code}` : 'review_reason_OTHER';
}

function OwnReviewStatus({ status, moderationReason }) {
  const [open, setOpen] = useState(false);
  if (status === 'hidden') {
    return (
      <div>
        <p>
          {I18n.t('review_hidden_message')}{' '}
          <button type="button" onClick={() => setOpen((value) => !value)} style={{ background: 'none', border: 0, padding: 0, color: '#1a73e8', cursor: 'pointer' }}>
            {I18n.t('review_view_reason')}
          </button>
        </p>
        {open ? <p>{I18n.t('review_hidden_reason_detail', { reason: I18n.t(reviewReasonKey(moderationReason)), email: REVIEW_SUPPORT_EMAIL })}</p> : null}
      </div>
    );
  }
  if (status === 'needs_review') {
    return <span style={{ display: 'inline-block', marginLeft: 8, padding: '2px 8px', borderRadius: 12, background: '#fff4d6' }}>{I18n.t('review_status_pending')}</span>;
  }
  return null;
}

function DetailSession({
  history,
  match,
  header,
  footer,
  getDetailSession,
  getDetailTopic,
  getListBuddyRole,
  removeSession,
  getProfileRoleBySession,
  trackingSession,
  buddyAcceptOrRejectSession,
  reportData,
  verifyJoinSession,
  getReasonReport,
  updatePageStatus,
  user,
}) {
  const sessionId = match.params.id;
  const [sessionInfo, setSessionInfo] = useState(null);
  const [profile, setProfile] = useState(null);
  const [onlyDateText, setOnlyDateText] = useState(null);
  const [dateText, setDateText] = useState(null);
  const [timeText, setTimeText] = useState(null);
  const [durationText, setDurationText] = useState(null);
  const [startTimeText, setStartTimeText] = useState(null);
  const [endTimeText, setEndTimeText] = useState(null);
  const [startTimeNotDayText, setStartTimeNotDayText] = useState(null);
  // senior buddy
  const [stateText, setStateText] = useState(null);
  const [styleState, setStyleState] = useState(null);
  const [visibleModal, setVisibleModal] = useState(false);
  const [showUserRatingModal, setShowUserRatingModal] = useState(false);
  const [showTopicRatingModal, setShowTopicRatingModal] = useState(false);
  const [sessionRatingModalOpenSignal, setSessionRatingModalOpenSignal] = useState(0);
  const ratingQueryHandledRef = useRef(false);

  const [buddyCanStartSession, setBuddyCanStartSession] = useState(false);
  const [isEndedSession, setIsEndedSession] = useState(false);
  const [isProcessingSession, setIsProcessingSession] = useState(false);
  const [isNotStartedSession, setIsNotStartedSession] = useState(false);
  const [buddyCanEditSession, setBuddyCanEditSession] = useState(false);
  const [visibleModalEnded, setVisibleModalEnded] = useState(false);
  const [visibleModalWaitingConfirm, setVisibleModalWaitingConfirm] = useState(false);

  // senior
  const [seniorCanStartSession, setSeniorCanStartSession] = useState(false);
  const [seniorWaitingConfirm, setWaitingConfirm] = useState(false);
  const [seniorCanRegisterSession, setSeniorCanRegisterSession] = useState(false);
  const [actionDisableOfSenior, setActionDisableOfSenior] = useState('');
  const [otherRegistered, setOtherRegistered] = useState(false);
  const [invalidTimeForRegister, setInvalidTimeForRegister] = useState(false);
  const [visibleModalOtherRegistered, setVisibleModalOtherRegistered] = useState(false);
  const [visibleModalInvalidTimeForRegister, setVisibleModalInvalidTimeForRegister] = useState(false);
  const [visibleModalInForBuddy, setVisibleModalInForBuddy] = useState(false);
  const [visibleModalAcceptSession, setVisibleModalAcceptSession] = useState(false);
  const [visibleModalRejectSession, setVisibleModalRejectSession] = useState(false);
  const [visibleModalSeniorProfile, setVisibleModalSeniorProfile] = useState(false);
  const [showAppDownloadModal, setShowAppDownloadModal] = useState(false);
  const scrollRef = useRef(null);
  const [showPageReadyJoinSession, setShowPageReadyJoinSession] = useState(false);
  const [intervalId, setIntervalId] = useState(null);
  const [noteAcceptBuddy, setNoteAcceptBuddy] = useState('');

  const [actionDisableOfBuddy, setActionDisableOfBuddy] = useState(false);
  const [reportReasons, setReportReasons] = useState([]);
  const [visibleModalReport, setVisibleModalReport] = useState(false);
  const [reportInfo, setReportInfo] = useState({ type: '', _id: '' });
  const [reportReason, setReportReason] = useState([]);
  const [reportDescription, setReportDescription] = useState('');
  const [isJoiningSession, setIsJoiningSession] = useState(false);
  const [isSubmittingReport, setIsSubmittingReport] = useState(false);

  // Cập nhật hiển thị trạng thái phiên (text + style) dựa trên state hiện tại
  const updateSessionStateDisplay = (sessionData) => {
    const state = sessionData?.state;
    let newStateText = '';
    let newStyleState = '';

    if (state === 'is_processing') {
      newStateText = I18n.t('ongoing');
      newStyleState = 'in_progress';
    } else if (state === 'is_not_started') {
      newStateText = I18n.t('upcoming');
      newStyleState = 'upcoming';
    } else if (state === 'is_ended') {
      newStateText = I18n.t('completed');
      newStyleState = 'ended';
    } else if (state === 'waiting_confirm') {
      newStateText = I18n.t('confirmation');
      newStyleState = 'in_progress';
    }

    setStyleState(newStyleState);
    setStateText(newStateText);
  };

  const normalizeLocalizedSessionFields = useCallback((sessionData) => {
    if (!sessionData) return sessionData;

    const next = { ...sessionData };

    next.titleVn = next.titleVn ?? next.title;
    next.personalDescriptionVn = next.personalDescriptionVn ?? next.personalDescription;
    next.descriptionVn = next.descriptionVn ?? next.description;

    if (I18n.language === 'en') {
      next.title = next.titleEn || next.titleVn || next.title || '';
      next.personalDescription = next.personalDescriptionEn || next.personalDescriptionVn || next.personalDescription || '';
      next.description = next.descriptionEn || next.descriptionVn || next.description || '';
    } else {
      next.title = next.titleVn || next.titleEn || next.title || '';
      next.personalDescription = next.personalDescriptionVn || next.personalDescriptionEn || next.personalDescription || '';
      next.description = next.descriptionVn || next.descriptionEn || next.description || '';
    }

    return next;
  }, [I18n.language]);

  const mergeDefinedFields = useCallback((base, updates) => {
    if (!updates) {
      return base;
    }

    const merged = { ...(base || {}) };
    Object.entries(updates).forEach(([key, value]) => {
      if (value !== undefined) {
        merged[key] = value;
      }
    });

    return merged;
  }, []);

  const fetchTopicRatingData = useCallback(
    async (topicId) => {
      if (!topicId) return null;
      try {
        const data = await getDetailTopic({ topicId });
        return data;
      } catch (err) {
        return null;
      }
    },
    [getDetailTopic],
  );

  const mergeTopicFieldsIntoSession = useCallback((sessionData, topicData) => {
    if (!topicData) {
      return sessionData;
    }
    return {
      ...sessionData,
      dataRatingTopic: topicData.dataRatingTopic ?? sessionData.dataRatingTopic,
      dataEvaluateBuddy: topicData.dataEvaluateBuddy ?? sessionData.dataEvaluateBuddy,
      guideStatus: sessionData.guideStatus ?? topicData.guideStatus,
      isGuideOnBreak: sessionData.isGuideOnBreak ?? topicData.isGuideOnBreak,
    };
  }, []);

  //----------------------------------------------------------------------------------------
  // Load session detail và rating data
  //----------------------------------------------------------------------------------------
  const loadSessionDetailAndRatingData = useCallback(async () => {
    try {
      const sessionDetail = await getDetailSession({ sessionId, notAddState: true });
      if (!sessionDetail) return null;
      const isGuide = isMvpUserGuide(user);
      const apiCall = isGuide ? getSeniorBuddyDetailSession : getSeniorDetailSession;
      const ratingData = await apiCall({ id: sessionId, notAddState: true });
      const fullData = {
        ...sessionDetail,
        needToEvaluate: ratingData?.needToEvaluate,
        dataRating: ratingData?.dataRating,
        dataEvaluateSenior: ratingData?.dataEvaluateSenior,
        dataEvaluateBuddy: ratingData?.dataEvaluateBuddy,
        dataRatingTopic: ratingData?.dataRatingTopic,
      };
      return fullData;
    } catch (error) {
      return null;
    }
  }, [getDetailSession, sessionId, user]);

  const updateSessionData = useCallback(async () => {
    if (!sessionId) return;

    try {
      const data = await loadSessionDetailAndRatingData();
      if (!data) return;

      const topicData = await fetchTopicRatingData(data.topicId);
      const normalizedData = normalizeLocalizedSessionFields(
        mergeTopicFieldsIntoSession(data, topicData),
      );

      setSessionInfo((prevSessionInfo) => {
        const mergedSession = mergeDefinedFields(prevSessionInfo, normalizedData);
        return normalizeLocalizedSessionFields(mergedSession);
      });

      handleCaseForBuddy(normalizedData);
      handleCaseForSenior(normalizedData);
      updateSessionStateDisplay(normalizedData);
    } catch (error) {
      console.error('Error updating session data:', error);
    }
  }, [sessionId, fetchTopicRatingData, loadSessionDetailAndRatingData, mergeDefinedFields, mergeTopicFieldsIntoSession, normalizeLocalizedSessionFields]);

  const fetchReportReasons = async () => {
    const response = await getReasonReport();
    if (response && response.data) {
      setReportReasons(
        response.data.map((item) => ({
          key: item.value || item.key,
          label: item.label || item.name,
          type: item.type,
        })),
      );
    }
  };

  useEffect(() => {
    updatePageStatus('loaded');
  }, [updatePageStatus]);

  useEffect(() => {
    if (!sessionId) return;
    fetchReportReasons();
    loadSessionDetailAndRatingData().then(async (data) => {
      if (!data) {
        return;
      }
      const topicData = await fetchTopicRatingData(data.topicId);
      const normalizedData = normalizeLocalizedSessionFields(
        mergeTopicFieldsIntoSession(data, topicData),
      );
      setSessionInfo(JSON.parse(JSON.stringify(normalizedData)));
      if (normalizedData.roleBuddyInSession) {
        getListBuddyRole().then((roles) => {
          if (!roles) {
            return;
          }
          const roleBuddyInSessionDetail = roles.find((item) => item.value === normalizedData.roleBuddyInSession);
          setSessionInfo((prevSessionInfo) => ({
            ...prevSessionInfo,
            roleBuddyInSessionDetail: roleBuddyInSessionDetail,
          }));
        });
      }
      const days = [
        I18n.t('sunday'),
        I18n.t('monday'),
        I18n.t('tuesday'),
        I18n.t('wednesday'),
        I18n.t('thursday'),
        I18n.t('friday'),
        I18n.t('saturday'),
      ];

      let dateText = formatSessionDay(data.startTime, days);
      setDateText(dateText);
      let timeText = formatSessionClockRange(data.startTime, data.endTime);
      setTimeText(timeText);
      let onlyDateText = formatSessionDate(data.startTime);
      setOnlyDateText(onlyDateText);

      let duration = moment(data.endTime).diff(moment(data.startTime), 'minutes');
      let hour = moment(data.endTime).diff(moment(data.startTime), 'hours');
      let minutes = duration % 60;
      let durationText =
        (hour >= 1 ? I18n.t('time_duration_h', { h: Math.round(hour) }) : '') +
        (minutes > 0 ? ' ' + I18n.t('time_duration_m', { m: minutes }) : '');
      setDurationText(durationText);

      let stateText = '';
      let styleState = '';
      if (data.state === 'is_processing') {
        stateText = I18n.t('ongoing');
        styleState = 'in_progress';
      } else if (data.state === 'is_not_started') {
        stateText = I18n.t('upcoming');
        styleState = 'upcoming';
      } else if (data.state === 'is_not_started_5_hours') {
        stateText = I18n.t('is_not_started_5_hours');
        styleState = 'upcoming';
      } else if (data.state === 'is_ended') {
        stateText = I18n.t('completed');
        styleState = 'ended';
      } else if (data.state === 'waiting_confirm') {
        stateText = I18n.t('confirmation');
        styleState = 'in_progress';
      }
      setStyleState(styleState);
      setStateText(stateText);

      setStartTimeText(formatSessionDateTimeWithDay(data.startTime, days));
      setStartTimeNotDayText(formatSessionClockWithDate(data.startTime));
      setEndTimeText(formatSessionClockWithDate(data.endTime, data.startTime));

      handleCaseForBuddy(normalizedData);
      handleCaseForSenior(normalizedData);
    });

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [
    fetchTopicRatingData,
    getListBuddyRole,
    loadSessionDetailAndRatingData,
    mergeTopicFieldsIntoSession,
    normalizeLocalizedSessionFields,
    setSessionInfo,
  ]);

  // Tạo các timer dựa trên startTime và endTime
  // để tại mốc startTime - 30 phút, đúng startTime và endTime sẽ tự gọi lại updateSessionData,
  // giúp nút Start session và trạng thái phiên được đồng bộ theo thời gian mà không cần setInterval liên tục.
  useEffect(() => {
    if (!sessionId || !sessionInfo?.startTime || !sessionInfo?.endTime) return;

    const now = moment();
    const startTime = moment(sessionInfo.startTime);
    const endTime = moment(sessionInfo.endTime);

    // Nếu phiên đã kết thúc thì không cần timer nào
    if (now.isSameOrAfter(endTime)) {
      return;
    }

    const preJoinTime = startTime.clone().subtract(30, 'minutes');

    let enableTimerId = null;
    let startTimerId = null;
    let disableTimerId = null;

    // Timer enable: chỉ tạo nếu hiện tại còn trước mốc preJoinTime
    if (now.isBefore(preJoinTime)) {
      const msToEnable = preJoinTime.diff(now);
      enableTimerId = setTimeout(() => {
        updateSessionData();
      }, msToEnable);
    }

    // Timer tại đúng thời điểm startTime:
    // dùng để đồng bộ lại state (is_not_started -> is_processing, v.v.)
    // chỉ tạo nếu hiện tại còn trước startTime
    if (now.isBefore(startTime)) {
      const msToStart = startTime.diff(now);
      startTimerId = setTimeout(() => {
        updateSessionData();
      }, msToStart);
    }

    // Timer disable: chỉ tạo nếu hiện tại còn trước endTime
    if (now.isBefore(endTime)) {
      const msToDisable = endTime.diff(now);
      disableTimerId = setTimeout(() => {
        updateSessionData();
      }, msToDisable);
    }

    return () => {
      if (enableTimerId) {
        clearTimeout(enableTimerId);
      }
      if (startTimerId) {
        clearTimeout(startTimerId);
      }
      if (disableTimerId) {
        clearTimeout(disableTimerId);
      }
    };
  }, [sessionId, sessionInfo?.startTime, sessionInfo?.endTime, updateSessionData]);

  // Khi tab quay lại trạng thái visible, đồng bộ lại trạng thái phiên một lần
  // để tránh lệch thời gian do tab ở background / máy sleep.
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible' && sessionInfo) {
        const now = moment();
        const endTime = sessionInfo?.endTime ? moment(sessionInfo.endTime) : null;

        // Nếu phiên chưa kết thúc thì đồng bộ lại data
        if (!endTime || now.isBefore(endTime)) {
          updateSessionData();
        }
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [sessionInfo, updateSessionData]);

  const profileRoleInfo = useMemo(() => {
    if (!sessionInfo) return null;
    if (user.type === 'senior' || user.type === 'explorer' || user.mvpUserType === 'explorer') {
      return {
        userId: sessionInfo?.infoAuthor?._id,
        role: 'seniorBuddy',
      };
    } else {
      return {
        userId: sessionInfo?.seniorRegisted?._id,
        role: 'senior',
      };
    }
  }, [user.type, user.mvpUserType, sessionInfo]);

  useEffect(() => {
    if (!sessionId || !profileRoleInfo?.userId) return;
    getProfileRoleBySession({ sessionId, userId: profileRoleInfo.userId, role: profileRoleInfo.role }).then(
      (response) => {
        setProfile({
          ...response,
          profileRole: profileRoleInfo.role,
        });
      },
    );
  }, [sessionId, profileRoleInfo?.userId, profileRoleInfo?.role, getProfileRoleBySession]);

  useEffect(() => {
    ratingQueryHandledRef.current = false;
  }, [sessionId]);

  // ?isShowRating=true: mở popup đánh giá khi cùng điều kiện với RatingPromoteBanner
  useEffect(() => {
    if (!sessionId || !sessionInfo || ratingQueryHandledRef.current) return;

    const sessionInfoMatchesRoute =
      String(sessionInfo._id) === String(sessionId) || String(sessionInfo.sessionUserId) === String(sessionId);
    if (!sessionInfoMatchesRoute) return;

    const params = new URLSearchParams(history.location.search);
    if (params.get('isShowRating') !== 'true') return;

    ratingQueryHandledRef.current = true;

    const canOpenSessionRatingPopup =
      sessionInfo?.needToEvaluate === true &&
      !(sessionInfo?.dataRating?.score > 0)

    if (canOpenSessionRatingPopup) {
      setSessionRatingModalOpenSignal((n) => n + 1);
    }

    params.delete('isShowRating');
    const nextSearch = params.toString();
    history.replace({
      pathname: history.location.pathname,
      search: nextSearch ? `?${nextSearch}` : '',
      hash: history.location.hash,
    });
  }, [sessionId, sessionInfo, history]);

  const trackingData = async () => {
    try {
      await trackingSession({ session_id: sessionId });
    } catch (error) {
      console.error('Error tracking data:', error);
    }
  };
  const openModalRemove = () => {
    setVisibleModal(true);
  };

  const openModalAccept = () => {
    setVisibleModalAcceptSession(true);
  };

  const openModalReject = () => {
    setVisibleModalRejectSession(true);
  };

  const filteredReportReasons = useMemo(() => {
    if (!reportInfo.type) {
      return reportReasons;
    }

    if (reportInfo.type === 'topic') {
      return reportReasons.filter((item) => item.type === 'topic' || item.type === 'both');
    } else {
      return reportReasons.filter((item) => item.type !== 'topic' || item.type === 'both');
    }
  }, [reportReasons, reportInfo.type]);

  const canJoinByTime = () => {
    if (!sessionInfo?.startTime || !sessionInfo?.endTime) {
      return null;
    }

    const now = moment();
    const startTime = moment(sessionInfo.startTime);
    const endTime = moment(sessionInfo.endTime);
    const preJoinTime = startTime.clone().subtract(30, 'minutes');

    if (now.isBefore(preJoinTime)) {
      return { canJoin: false, reason: 'too_early' };
    }

    if (now.isSameOrAfter(endTime)) {
      return { canJoin: false, reason: 'too_late' };
    }

    return { canJoin: true, reason: null };
  };

  const readyJoinSession = () => {
    const timeCheck = canJoinByTime();

    // Nếu có đủ thông tin thời gian thì ưu tiên kiểm tra theo thời gian thực
    if (timeCheck && !timeCheck.canJoin) {
      setVisibleModalEnded(true);
      return;
    }

    // Fallback trong trường hợp không có startTime/endTime
    if (!timeCheck && (isEndedSession || (isNotStartedSession && !sessionInfo?.infoExtra?.canPreJoin))) {
      setVisibleModalEnded(true);
      return;
    }

    window.open(`${window.location.origin}/meeting-join/${sessionId}`, '_blank', 'noopener,noreferrer');
  };

  const notReadyJoinSession = () => {
    setShowPageReadyJoinSession(false);
  };

  const joinSession = async () => {
    setShowPageReadyJoinSession(false);

    const timeCheck = canJoinByTime();

    // Kiểm tra lại thời gian một lần nữa khi user bấm Join ở màn hình tiếp theo
    if (timeCheck && !timeCheck.canJoin) {
      setVisibleModalEnded(true);
      return;
    }

    // Fallback khi không có thông tin thời gian
    if (!timeCheck && (isEndedSession || (isNotStartedSession && !sessionInfo?.infoExtra?.canPreJoin))) {
      setVisibleModalEnded(true);
      return;
    }

    if (isProcessingSession || !actionDisableOfSenior) {
      // check xem co duoc phep join hay khong
      const verifyData = await verifyJoinSession({
        sessionId: sessionInfo.sessionUserId,
        sessionUserId: sessionInfo.sessionUserId,
      });
      if (!verifyData || verifyData.status != 'OK') {
        toast.error(I18n.t('unable_join_session'), {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          className: 'toast-error-container toast-error-container-after',
          theme: 'colored',
        });
        return;
      }
      // setIsJoiningSession(true);
      // setIsLoading(true);
      // setLoadingText('Joining the session...');

      history.push(`/session-video/${sessionId}`);
      return;
    }
  };

  const openWaitingConfirmModal = () => {
    setVisibleModalWaitingConfirm(true);
  };

  const closeWaitingConfirmModal = () => {
    setVisibleModalWaitingConfirm(false);
  };

  const openModalWhenStartOrProccessingSession = () => {
    if (isEndedSession) {
      setVisibleModalEnded(true);
      return;
    }
  };

  const closeModalEndedSession = () => {
    setVisibleModalEnded(false);
  };

  const closeModalRemoveSession = () => {
    setVisibleModal(false);
  };

  const closeModalOtherRegistered = () => {
    setVisibleModalOtherRegistered(false);
  };

  const closeModalInvalidTimeForRegister = () => {
    setVisibleModalInvalidTimeForRegister(false);
  };

  const viewProfile = () => {
    if (!profile) {
      let role = 'senior';
      let userId = sessionInfo?.seniorRegisted?._id;
      if (user.type === 'senior' || user.type === 'explorer' || user.mvpUserType === 'explorer') {
        role = 'seniorBuddy';
        userId = sessionInfo?.infoAuthor?._id;
      }

      getProfileRoleBySession({ sessionId, userId, role }).then((response) => {
        setProfile({
          ...response,
          profileRole: role,
        });
      });
    }
    setVisibleModalSeniorProfile(true);
  };

  const openModalInformationBuddy = () => {
    setVisibleModalInForBuddy(true);
  };

  const closeModalInformationBuddy = () => {
    setVisibleModalInForBuddy(false);
  };

  const closeModalAcceptSession = () => {
    setVisibleModalAcceptSession(false);
  };

  const closeModalSeniorProfile = () => {
    setVisibleModalSeniorProfile(false);
  };

  const formatAgeAndBirthYear = (dobString) => {
    if (!dobString) return dobString;
    const result = getAgeAndBirthYear(dobString);
    if (!result) return I18n.t('profile_dob', { age: 0, year: dobString });
    return I18n.t('profile_dob', { age: result.age ?? 0, year: result.year });
  };

  const renderProfileRatingSection = () => {
    if (!profile?.totalRating || profile.totalRating <= 0) return null;

    const firstItem = profile.listRatings?.[0];
    const evaluation = firstItem ? (firstItem.evaluation || firstItem) : null;
    const reviewerRoleLabel = profile.profileRole === 'senior'
      ? I18n.t('account_type_selection_senior_buddy')
      : I18n.t('account_type_selection_senior');

    return (
      <div style={{ width: '100%', margin: '16px 0' }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#374151',
          borderRadius: '8px',
          padding: '12px 16px',
          marginBottom: '12px',
        }}>
          <img src={starActive} alt="" style={{ width: '24px', height: '24px', marginRight: '8px' }} />
          <span style={{ color: '#F9FAFB', fontSize: '18px', fontWeight: 600, marginRight: '8px' }}>{formatRating(profile.avgRating)}</span>
          <span style={{ color: '#9CA3AF', margin: '0 8px' }}>•</span>
          <span style={{ color: '#9CA3AF', fontSize: '14px' }}>
            {profile.totalRating.toLocaleString()} {I18n.t('ratings_count')}
          </span>
        </div>

        {evaluation && (
          <RatingListItem
            roleLabel={reviewerRoleLabel}
            name={maskUserName(firstItem.name)}
            score={evaluation.score}
            time={evaluation.time}
            sessionTitle={evaluation.sessionTitle}
            contentExtra={evaluation.contentExtra}
            content={evaluation.content}
          />
        )}

        <div style={{ textAlign: 'center', marginTop: '12px' }}>
          <button
            onClick={() => {
              closeModalSeniorProfile();
              const timeout = setTimeout(() => {
                clearTimeout(timeout);
                setShowUserRatingModal(true);
              }, 500);
            }}
            style={{
              background: 'transparent',
              border: '1px solid #61E6BD',
              color: '#61E6BD',
              borderRadius: '8px',
              padding: '8px 24px',
              fontSize: '14px',
              fontWeight: 500,
              cursor: 'pointer',
            }}
          >
            {I18n.t('view_all_ratings', { count: profile.totalRating.toLocaleString() })}
          </button>
        </div>
      </div>
    );
  };

  const closeModalRejectSession = () => {
    setVisibleModalRejectSession(false);
  };

  const handleValueAcceptBuddy = (event) => {
    setNoteAcceptBuddy(event.target.value);
  };
  const acceptByBuddy = async () => {
    if (!actionDisableOfBuddy) {
      setActionDisableOfBuddy(true);
      const note = noteAcceptBuddy;
      const response = await buddyAcceptOrRejectSession({
        idSession: sessionInfo.sessionUserId,
        note: note,
        status: 'confirm',
        seniorId: sessionInfo?.seniorRegisted?._id,
      });
      setActionDisableOfBuddy(false);
      if (response.status == 'OK') {
        toast.success(I18n.t('confirm_session_success'), {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: 'colored',
          className: 'toast-success-container toast-success-container-after',
        });

        window.location.reload();
      } else {
        toast.error(response.message, {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          className: 'toast-error-container toast-error-container-after',
          theme: 'colored',
        });
        console.log('response', response);
      }
    }
  };

  const rejectByBuddy = async () => {
    if (!actionDisableOfBuddy) {
      setActionDisableOfBuddy(true);
      const note = noteAcceptBuddy;
      const response = await buddyAcceptOrRejectSession({
        idSession: sessionInfo.sessionUserId,
        note: note,
        status: 'reject',
        seniorId: sessionInfo?.seniorRegisted?._id,
      });
      setActionDisableOfBuddy(false);
      if (response.status === 'OK') {
        toast.success(I18n.t('reject_session_success'), {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: 'colored',
          className: 'toast-success-container toast-success-container-after',
        });
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      } else {
        toast.error(response.message, {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          className: 'toast-error-container toast-error-container-after',
          theme: 'colored',
        });
        console.log('response', response);
      }
    }
  };

  const removeSessionData = async () => {
    const dataRemove = await removeSession({ _id: sessionInfo._id });
    if (dataRemove.status == 'OK') {
      toast.success(I18n.t('delete_session_success'), {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: 'colored',
        className: 'toast-success-container toast-success-container-after',
      });
      history.push('/my-session');
    } else {
      toast.error(dataRemove?.message, {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: 'colored',
      });
    }

    return;
  };

  const handleCaseForBuddy = (sessionInfo) => {
    // Check isOfMine - handle both 1/0 (from API) and true/false
    const isOfMine = sessionInfo?.isOfMine === 1 || sessionInfo?.isOfMine === true;
    // Guide can interact with session if:
    // 1. isOfMine is true (guide is the host), OR
    // 2. seniorRegisted exists (explorer has booked this guide), OR
    // 3. needToConfirm is true (guide needs to confirm/reject)
    const canInteract = isOfMine;

    if (canInteract) {
      if (sessionInfo.state == 'is_ended' || sessionInfo?.infoExtra?.state == 'is_ended') {
        setIsEndedSession(true);
        setIsNotStartedSession(false);
        setIsProcessingSession(false);
      }

      if (sessionInfo.state == 'is_processing' || sessionInfo?.infoExtra?.state == 'is_processing') {
        setIsProcessingSession(true);
        setIsNotStartedSession(false);
        // Nếu state đang là is_processing nhưng đã quá giờ kết thúc thì set lại là is_ended
        // Đây là trường hợp khi session đang process cho việc kết thúc chưa kịp chuyển state nhưng user đã cố tình bấm lại join
        if (sessionInfo?.endTime && moment(sessionInfo?.endTime).isBefore(moment())) {
          setIsEndedSession(true);
        } else {
          setIsEndedSession(false);
        }
      }

      if (
        sessionInfo.state == 'is_not_started_5_hours' ||
        sessionInfo.state == 'is_not_started' ||
        !sessionInfo.state ||
        sessionInfo?.infoExtra?.state == 'is_not_started'
      ) {
        setIsNotStartedSession(true);
        setIsProcessingSession(false);
        setIsEndedSession(false);
      }

      if (!sessionInfo?.seniorRegisted && (sessionInfo.state == 'is_not_started' || !sessionInfo.state)) {
        setIsNotStartedSession(true);
        setBuddyCanEditSession(true);
      }
      if (!sessionInfo?.seniorRegisted && sessionInfo.state == 'is_ended') {
        setBuddyCanStartSession(true);
      }

      // neu da co nguoi dang ky va da dien ra thi se disable
      if (sessionInfo?.seniorRegisted) {
        setBuddyCanStartSession(true);
      }

      // Guide can interact if needToConfirm is true (explorer has booked, waiting for guide to confirm/reject)
      if (sessionInfo?.needToConfirm) {
        setBuddyCanStartSession(true);
      }
    } else {
      // Reset states if not owner and no explorer has booked
      setBuddyCanStartSession(false);
      setBuddyCanEditSession(false);
    }
    return false;
  };

  const handleCaseForSenior = (sessionInfo) => {
    let infoExtra = sessionInfo.infoExtra || {};
    setActionDisableOfSenior(infoExtra.isDisable ? 'btn-disabled' : '');
    let waitingConfirm = infoExtra.waitingConfirm;

    if (infoExtra.canPreJoin && !infoExtra.isDisable) {
      setSeniorCanStartSession(true);
    }

    if (sessionInfo.isRegistered) {
      setSeniorCanStartSession(true);
      setSeniorCanRegisterSession(false);
    } else {
      setSeniorCanRegisterSession(true);
    }

    if (waitingConfirm) {
      setSeniorCanStartSession(false);
      setWaitingConfirm(true);
    } else {
      setWaitingConfirm(false);
    }

    if (
      sessionInfo.state == 'is_not_started_5_hours' ||
      sessionInfo.state == 'is_not_started' ||
      infoExtra?.state == 'is_not_started'
    ) {
      setIsNotStartedSession(true);
      setIsProcessingSession(false);
      setIsEndedSession(false);
    }

    if (sessionInfo.state == 'is_ended' || infoExtra?.state == 'is_ended') {
      setIsEndedSession(true);
      setIsNotStartedSession(false);
      setIsProcessingSession(false);
    }

    if (sessionInfo.state == 'is_processing' || infoExtra?.state == 'is_processing') {
      setIsProcessingSession(true);
      setIsNotStartedSession(false);
      // Nếu state đang là is_processing nhưng đã quá giờ kết thúc thì set lại là is_ended
      // Đây là trường hợp khi session đang process cho việc kết thúc chưa kịp chuyển state nhưng user đã cố tình bấm lại join
      if (sessionInfo?.endTime && moment(sessionInfo?.endTime).isBefore(moment())) {
        setIsEndedSession(true);
      } else {
        setIsEndedSession(false);
      }
    }

    if (infoExtra.otherRegistered) {
      setOtherRegistered(true);
      setSeniorCanRegisterSession(true);
      setSeniorCanStartSession(false);
    }

    if (infoExtra.invalidTimeForRegister) {
      setInvalidTimeForRegister(true);
    }

    return false;
  };

  const handleReport = (type, _id) => {
    console.log('Report:', { type, _id });
    console.log('profile:', profile);
    openModalReport(type, _id);
  };

  const handleReportReasonChange = (reason) => {
    setReportReason((prevReasons) => {
      if (prevReasons.includes(reason)) {
        // Nếu đã chọn thì bỏ chọn
        return prevReasons.filter((r) => r !== reason);
      } else {
        // Nếu chưa chọn thì thêm vào
        return [...prevReasons, reason];
      }
    });
  };

  const handleReportDescriptionChange = (event) => {
    const value = event.target.value;
    if (value.length <= 500) {
      setReportDescription(value);
    }
  };

  const submitReport = async () => {
    if (isSubmittingReport) {
      return;
    }

    const params = {
      type: reportInfo.type,
      _id: reportInfo._id,
      reason: reportReason.join(','),
      description: reportDescription,
    };

    console.log('Submit Report:', params);

    setIsSubmittingReport(true);
    try {
      const response = await reportData(params);

      if (response && response.status === 'OK') {
        toast.success(I18n.t('report_success'), {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: 'colored',
          className: 'toast-success-container toast-success-container-after',
        });
        closeModalReport();
      } else {
        toast.error(response?.message || I18n.t('something_wrong'), {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          className: 'toast-error-container toast-error-container-after',
          theme: 'colored',
        });
        setIsSubmittingReport(false);
      }
    } catch (error) {
      console.error('Report error:', error);
      toast.error(I18n.t('something_wrong'), {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        className: 'toast-error-container toast-error-container-after',
        theme: 'colored',
      });
      setIsSubmittingReport(false);
    }
  };

  const openModalReport = (type, _id) => {
    setReportInfo({ type, _id });
    setVisibleModalReport(true);
  };

  const closeModalReport = () => {
    setVisibleModalReport(false);
    setReportInfo({ type: '', _id: '' });
    setReportReason([]);
    setReportDescription('');
    setIsSubmittingReport(false);
  };

  const completeInfo = sessionInfo?.isCompleted ?? '';
  const completeMap = {
    done: I18n.t('session_completed'),
    failed: I18n.t('session_failed'),
    not_done: I18n.t('session_not_completed'),
  };
  const completeString = completeMap[completeInfo] ?? '';

  const isSeniorOrExplorerViewer = useMemo(() => {
    if (!user || !sessionInfo) {
      return false;
    }
    const isOfMine = sessionInfo.isOfMine === 1 || sessionInfo.isOfMine === true;
    const isViewer =
      user.type === 'senior' ||
      user.type === 'explorer' ||
      user.mvpUserType === 'explorer' ||
      user.type === 'both';
    return isViewer && !isOfMine;
  }, [user, sessionInfo]);

  const showGuideUnavailableRegisterUx = useMemo(() => {
    if (!sessionInfo || !isSeniorOrExplorerViewer) {
      return false;
    }
    const isRegistered = sessionInfo.isRegistered === 1 || sessionInfo.isRegistered === true;
    return isTopicGuideOnBreak(sessionInfo) && !isRegistered;
  }, [sessionInfo, isSeniorOrExplorerViewer]);

  //----------------------------------------------------------------------------------------
  // Render Section
  //----------------------------------------------------------------------------------------
  const renderRatingBanner = () => {
    const isGuide = isMvpUserGuide(user);
    const showRatingBanner = sessionInfo?.needToEvaluate === true;

    // Nếu session đã end quá 7 ngày mà chưa đánh giá thì hiển thị: Phiên kết nối này không có đánh giá
    const isShowNoRatingBanner =
      sessionInfo?.state === 'is_ended' &&
      sessionInfo?.endTime &&
      moment(sessionInfo?.endTime).isBefore(moment().subtract(7, 'days'));
    // Nếu session hiện tại không phải của current user thì không hiển thị rating banner
    if (
      user &&
      (user.type == 'guide' || user.mvpUserType == 'guide' || user.role == 'guide') &&
      !sessionInfo?.isOfMine
    ) {
      return null;
    }

    if (
      user &&
      (user.type === 'senior' || user.type === 'explorer' || user.mvpUserType === 'explorer' || user.type === 'both') &&
      (seniorWaitingConfirm || otherRegistered)
    ) {
      return null;
    }

    // CEDP-420: Review ẩn không có điểm. Có status hoặc điểm đều là review của chính user.
    const dataRating = sessionInfo?.dataRating;
    const isUserHasRatingInThisSession = !!dataRating?.status || dataRating?.score > 0;
    if (dataRating?.status === 'hidden') {
      return (
        <div className="action-session" style={{ marginTop: '20px' }}>
          <div className="detail">
            <OwnReviewStatus status="hidden" moderationReason={dataRating.moderationReason} />
          </div>
        </div>
      );
    }
    if (isUserHasRatingInThisSession) {
      const score = Math.min(5, Math.max(0, Number(dataRating?.score) || 0));
      const sentimentKey = score > 0 ? RATING_STAR_LABEL_KEYS[score - 1] : 'ratting_none';
      const rawContent = dataRating?.content;
      const normalizeTag = (item) => {
        if (item == null) return null;
        if (typeof item === 'string') {
          const s = item.trim();
          return s || null;
        }
        if (typeof item === 'object' && item.label != null) {
          const s = String(item.label).trim();
          return s || null;
        }
        return null;
      };
      const tagList = Array.isArray(rawContent)
        ? rawContent.map(normalizeTag).filter(Boolean)
        : rawContent
          ? [normalizeTag(rawContent)].filter(Boolean)
          : [];
      const ratedDate =
        dataRating?.time != null && moment(dataRating.time).isValid()
          ? formatSessionDateDashed(dataRating.time)
          : '';

      return (
        <div className="action-session" style={{ marginTop: '20px' }}>
          <div className="detail session-detail-my-rating">
            <div className="session-detail-my-rating__stars-wrap">
              <RatingStarsDisplay score={score} size={32} variant="img" />
              <p className="session-detail-my-rating__sentiment">
                {I18n.t(sentimentKey)}
                <OwnReviewStatus status={dataRating?.status} />
              </p>
            </div>
            {dataRating?.contentExtra ? (
              <p className="session-detail-my-rating__comment">{dataRating.contentExtra}</p>
            ) : null}
            {tagList.length > 0 ? (
              <div className="session-detail-my-rating__tags">
                {tagList.map((tag, idx) => (
                  <span key={`${tag}-${idx}`} className="session-detail-my-rating__tag">
                    {tag}
                  </span>
                ))}
              </div>
            ) : null}
            {ratedDate ? (
              <p className="session-detail-my-rating__date">
                {I18n.t('session_detail_my_rating_date', { date: ratedDate })}
              </p>
            ) : null}
          </div>
        </div>
      );
    }

    if (isShowNoRatingBanner) {
      return (
        <div className="action-session" style={{ marginTop: '20px' }}>
          <div className="detail">
            <p>{I18n.t('session_detail_no_rating')}</p>
          </div>
        </div>
      );
    }

    if (showRatingBanner) {
      return (
        <div className="action-session" style={{ marginTop: '20px' }}>
          <div className="detail">
            <RatingPromoteBanner
              sessionId={sessionInfo?.sessionUserId || sessionId}
              onRatingSuccess={updateSessionData}
              isBuddy={!isGuide}
              openModalSignal={sessionRatingModalOpenSignal}
            />
          </div>
        </div>
      );
    }

    return null;
  };

  const renderDesktopAppDownloadPrompt = () => {
    if (isEndedSession) {
      return null;
    }

    return (
      <p className="session-detail-app-download" data-testid="session-detail-app-download">
        {I18n.t('meeting_join_bottom_hint')}
        <button
          type="button"
          className="session-detail-app-download__link"
          onClick={() => setShowAppDownloadModal(true)}
        >
          {I18n.t('meeting_join_bottom_link')}
        </button>
      </p>
    );
  };

  const renderButtonStartSession = () => {
    if (isEndedSession) {
      return (
        <div>
          <p>{I18n.t('time_start_session')}</p>
          <p className="time">{startTimeText}</p>
          <button
            onClick={openModalWhenStartOrProccessingSession}
            type="button"
            className="btn-create-session btn-disabled"
          >
            {I18n.t('start_session')}
          </button>
        </div>
      )
    }

    if (isNotStartedSession || isProcessingSession) {
      return (
      <div>
        <p>{I18n.t('time_start_session')}</p>
        <p className="time">{startTimeText}</p>
        <button
          type="button"
          onClick={readyJoinSession}
          className={`btn-create-session ${isEndedSession || (isNotStartedSession && !sessionInfo?.infoExtra?.canPreJoin) ? 'btn-disabled' : ''}`}
        >
          {I18n.t('start_session')}
        </button>
        {renderDesktopAppDownloadPrompt()}
      </div>
    )}

    return null;
  };

  const renderButtonStartSessionExplorer = () => {
    if (seniorCanStartSession) {
      return (
        <>
          <button
            onClick={readyJoinSession}
            type="button"
            className={`btn-create-session ${isEndedSession || (isNotStartedSession && !sessionInfo?.infoExtra?.canPreJoin) ? 'btn-disabled' : ''}`}
          >
            {I18n.t('start_session')}
          </button>
          {renderDesktopAppDownloadPrompt()}
        </>
      )
    }

    if (seniorWaitingConfirm) {
      return (
        <div>
          <p>{I18n.t('registered_awaiting_buddy_join')}</p>
          <button
            onClick={openWaitingConfirmModal}
            type="button"
            className={`btn-create-session ${actionDisableOfSenior}`}
          >
            {I18n.t('start_session')}
          </button>
          {renderDesktopAppDownloadPrompt()}
        </div>
      )
    }

    return null;
  }

  return (
    <div id="site_wrapper" className={showPageReadyJoinSession ? 'ai-support-session-page' : undefined}>
      {showPageReadyJoinSession ? (
        <div className="ai-support-session-page__viewport">
          <div>{header}</div>
          <AiSupportSessionVideo
            sessionInfo={sessionInfo}
            sessionId={sessionId}
            joinSession={joinSession}
            goBack={notReadyJoinSession}
          />
        </div>
      ) : (
        <>
          <div>{header}</div>
          <main className="main" ref={scrollRef}>
            <div className="container">
              <div className="row detail-session">
                <div className="col-lg-8 col-md-8 col-sm-12 mb-8">
                  <div className="title">{sessionInfo?.title}</div>
                  <div className="d-flex align-items-center">
                    {sessionInfo?.categoryName && <div className="categoryName">{sessionInfo?.categoryName}</div>}
                    {sessionInfo?.categoryName && sessionInfo?.roleBuddyInSessionDetail ? (
                      <div
                        style={{
                          width: '8px',
                          height: '8px',
                          backgroundColor: '#D9D9D9',
                          borderRadius: '50%',
                          margin: '20px 16px 0',
                        }}
                      ></div>
                    ) : null}
                    {sessionInfo?.roleBuddyInSessionDetail && (
                      <div className="categoryName">{sessionInfo?.roleBuddyInSessionDetail?.label}</div>
                    )}
                  </div>
                  <div className="detail-time">
                    <span>
                      <img src={videoTime} />
                    </span>
                    <span className="date">{dateText}</span>
                    <span className="dot"></span>
                    <span> {timeText} </span>
                    <span className="duration-icon">
                      <img src={timer} />
                    </span>
                    <span className="duration-text">{durationText}</span>
                    {sessionInfo?.dataRatingTopic != null && (
                      <>
                        <TotalRatingsComponent
                          totalPointEvaluating={sessionInfo.dataRatingTopic.totalPointEvaluating}
                          totalEvaluating={sessionInfo.dataRatingTopic.totalEvaluating}
                          onClick={() => setShowTopicRatingModal(true)}
                          style={{ marginLeft: '20px' }}
                        />
                      </>
                    )}
                  </div>

                  <div className="detail-time">
                    <span>
                      <img src={topicLanguage} />
                    </span>
                    <span className="date">
                      {I18n.t('topic_language', { topic_language: sessionInfo?.languages?.join(', ') })}
                    </span>
                  </div>

                  {user &&
                    (user.type == 'guide' || user.mvpUserType == 'guide' || user.role == 'guide') &&
                    sessionInfo?.isOfMine && (
                      <div className="info-user">
                        <div className="avatar" onClick={() => viewProfile()}>
                          <CustomAccountLogo userLabel={I18n.t('account_type_selection_senior')} />
                        </div>
                        <div className="info-detail" style={{ flex: 1 }}>
                          <div className="d-flex align-items-center justify-content-between">
                            <div onClick={() => viewProfile()} style={{ cursor: 'pointer' }}>
                              {sessionInfo?.seniorRegisted && (
                                <p className="name">{sessionInfo?.seniorRegisted?.name}</p>
                              )}
                              {sessionInfo?.seniorRegisted && (
                                <p className="title">{I18n.t('user_register_session')}</p>
                              )}
                              {!sessionInfo?.seniorRegisted && (
                                <p className="title">{I18n.t('no_one_register_session')}</p>
                              )}
                              {
                                <p>
                                  <span className={styleState}>{stateText}</span>
                                  {sessionInfo?.seniorRegisted &&
                                    stateText &&
                                    styleState !== 'in_progress' &&
                                    styleState !== 'upcoming' && (
                                      <>
                                        {' '}
                                        {stateText && completeString && <span> | </span>}
                                        <span className={`detail ${completeInfo}`}>{completeString}</span>
                                      </>
                                    )}
                                </p>
                              }
                            </div>
                            {sessionInfo?.dataEvaluateSenior && (
                              <CompactRatingDisplay
                                score={sessionInfo.dataEvaluateSenior.score}
                                hasRating={sessionInfo.dataEvaluateSenior.totalRating > 0}
                                onClick={() => setShowUserRatingModal(true)}
                                isUserRating={true}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    )}

                  {user && (user.type == 'senior' || user.type == 'explorer' || user.mvpUserType == 'explorer') && (
                    <div>
                      <div className="info-user">
                        <div className="avatar" onClick={() => viewProfile()}>
                          <CustomAccountLogo userLabel={I18n.t('account_type_selection_senior_buddy')} />
                        </div>
                        <div className="info-detail" style={{ flex: 1 }}>
                          <div className="d-flex align-items-center justify-content-between">
                            <div onClick={() => viewProfile()} style={{ cursor: 'pointer' }}>
                              {sessionInfo?.infoAuthor?.name && <p className="name">{sessionInfo?.infoAuthor?.name}</p>}
                              {profile?.rewards && profile?.rewards.length ? (
                                <>
                                  <div className="three-dot">{profile?.rewards[0]}</div>
                                  <a
                                    href="#"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      viewProfile();
                                    }}
                                    className="detail-buddy"
                                  >
                                    {I18n.t('details')}
                                  </a>
                                </>
                              ) : (
                                sessionInfo?.infoAuthor?.name && (
                                  <a
                                    href="#"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      viewProfile();
                                    }}
                                    className="detail-buddy"
                                  >
                                    {I18n.t('details')}
                                  </a>
                                )
                              )}
                            </div>
                            {sessionInfo?.dataEvaluateBuddy && (
                              <CompactRatingDisplay
                                score={
                                  sessionInfo.dataEvaluateBuddy.score ||
                                  sessionInfo.dataEvaluateBuddy.totalPointEvaluating
                                }
                                hasRating={
                                  sessionInfo.dataEvaluateBuddy.total > 0 ||
                                  sessionInfo.dataEvaluateBuddy.totalEvaluating > 0
                                }
                                onClick={() => setShowUserRatingModal(true)}
                                isUserRating={true}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {sessionInfo?.images && Array.isArray(sessionInfo.images) && sessionInfo.images.length > 0 && (
                    <div className="image">
                      <img src={sessionInfo.images[0]} alt={sessionInfo.title || 'Session image'} />
                    </div>
                  )}

                  <div className="description">
                    <div
                      className="detail-description"
                      dangerouslySetInnerHTML={{ __html: sessionInfo?.description }}
                    ></div>
                  </div>
                </div>

                <div className="col-lg-4 col-md-4 col-sm-12 mb-4">
                  {showGuideUnavailableRegisterUx && (
                    <div className="action-session">
                      <div className="detail">
                        <div
                          className="session-guide-unavailable-banner"
                          data-testid="session-guide-unavailable-banner"
                        >
                          <img src={warning} alt="" />
                          <span>{I18n.t('topic_detail_guide_unavailable_banner')}</span>
                        </div>
                        <button
                          type="button"
                          className="btn-create-session btn-disabled"
                          disabled
                          data-testid="session-register-disabled-btn"
                        >
                          {I18n.t('register')}
                        </button>
                      </div>
                    </div>
                  )}

                  {user && (user.type == 'guide' || user.mvpUserType == 'guide' || user.role == 'guide') && (
                    <div className="action-session">
                      {/* Only show "other session" message if guide cannot interact with this session */}
                      {(() => {
                        // Check isOfMine - handle both 1/0 (from API) and true/false
                        const isOfMine = sessionInfo?.isOfMine === 1 || sessionInfo?.isOfMine === true;
                        const canInteract = isOfMine;
                        return !canInteract;
                      })() && (
                        <div className="detail">
                          <p className="other-session">{I18n.t('session_detail_other_author')}</p>
                        </div>
                      )}

                      {/*buddy có thể bắt đầu phiên*/}
                      {buddyCanStartSession && (
                        <div className="detail">
                          {sessionInfo?.needToConfirm && (
                            <div className="action">
                              <div href="" onClick={openModalReject} className="btn-remove-session">
                                {I18n.t('denied')}
                              </div>
                              <div onClick={openModalAccept} className="btn-edit-session btn-accept-session">
                                {I18n.t('agree')}
                              </div>
                            </div>
                          )}
                          {renderButtonStartSession()}
                        </div>
                      )}
                    </div>
                  )}

                  {user &&
                    (user.type === 'senior' || user.type === 'explorer' || user.mvpUserType === 'explorer' || user.type === 'both') &&
                    (seniorWaitingConfirm ||
                      otherRegistered ||
                      invalidTimeForRegister ||
                      seniorCanStartSession ||
                      seniorWaitingConfirm) && (
                      <div className="action-session">
                        <div className="detail">
                          {otherRegistered && <p>{I18n.t('someone_has_already_registered')}</p>}
                          {invalidTimeForRegister && <p>{I18n.t('session_register_5h')}</p>}
                          {seniorCanStartSession && (
                            <div>
                              <p>{I18n.t('time_start_session')}</p>
                              <p className="time">{startTimeText}</p>
                            </div>
                          )}
                          {renderButtonStartSessionExplorer()}

                        </div>
                      </div>
                    )}
                  {renderRatingBanner()}
                </div>
              </div>
            </div>
          </main>
        </>
      )}

      {footer}
      <KambriaMeetingDownloadModal show={showAppDownloadModal} onHide={() => setShowAppDownloadModal(false)} />
      <ModalPopup
        size="sm"
        show={visibleModal}
        onHide={closeModalRemoveSession}
        id="remove-session-modal"
        style={{ opacity: 1 }}
        aria-labelledby="contained-modal-title-vcenter"
      >
        <ModalHeader>
          <a
            type="button"
            className="close-button-forget"
            data-dismiss="modal"
            aria-label="Close"
            onClick={closeModalRemoveSession}
          >
            x
          </a>
        </ModalHeader>
        <ModalPopup.Body>
          <div className="image">
            <img src={removeSessionImage} />
          </div>
          <p className="title">{I18n.t('delete_session_title')}</p>

          <div className="content">
            <span>{I18n.t('delete_session_des')}</span>
          </div>
        </ModalPopup.Body>
        <ModalPopup.Footer>
          <div onClick={removeSessionData} className="btn remove">
            {I18n.t('delete_session_btn')}
          </div>
          <div onClick={closeModalRemoveSession} className="btn cancel">
            {I18n.t('delete_session_cancel')}
          </div>
        </ModalPopup.Footer>
      </ModalPopup>

      <ModalPopup
        size="sm"
        show={visibleModalEnded}
        onHide={closeModalEndedSession}
        id="ended-session-modal"
        style={{ opacity: 1 }}
        aria-labelledby="contained-modal-title-vcenter"
      >
        <ModalHeader>
          <a
            type="button"
            className="close-button-forget"
            data-dismiss="modal"
            aria-label="Close"
            onClick={closeModalEndedSession}
          >
            x
          </a>
        </ModalHeader>
        <ModalPopup.Body>
          <div className="image">
            <img src={sessionTimeImage} />
          </div>
          <p className="title">
            {isEndedSession && <span>{I18n.t('session_end_at_time', { time: endTimeText })}</span>}
            {isNotStartedSession && <span>{I18n.t('session_start_at_time', { time: startTimeNotDayText })}</span>}
          </p>

          <div className="content">
            {isEndedSession && <span>{I18n.t('session_explore')}</span>}
            {isNotStartedSession && <span>{I18n.t('session_started_yet')}</span>}
          </div>
        </ModalPopup.Body>
        <ModalPopup.Footer>
          <div onClick={closeModalEndedSession} className="btn cancel">
            {I18n.t('understand')}
          </div>
        </ModalPopup.Footer>
      </ModalPopup>

      <ModalPopup
        size="sm"
        show={visibleModalOtherRegistered}
        onHide={closeModalOtherRegistered}
        id="other-registered-session-modal"
        style={{ opacity: 1 }}
        aria-labelledby="contained-modal-title-vcenter"
      >
        <ModalHeader>
          <a
            type="button"
            className="close-button-forget"
            data-dismiss="modal"
            aria-label="Close"
            onClick={closeModalOtherRegistered}
          >
            x
          </a>
        </ModalHeader>
        <ModalPopup.Body>
          <div className="image">
            <img src={otherRegisteredImg} />
          </div>
          <p className="title">
            <span>{I18n.t('session_already_registered')}</span>
          </p>

          <div className="content">
            <span>{I18n.t('session_has_registered_when_register')}</span>
          </div>
        </ModalPopup.Body>
        <ModalPopup.Footer>
          <div onClick={closeModalOtherRegistered} className="btn cancel">
            {I18n.t('understand')}
          </div>
        </ModalPopup.Footer>
      </ModalPopup>

      <ModalPopup
        size="sm"
        show={visibleModalInvalidTimeForRegister}
        onHide={closeModalInvalidTimeForRegister}
        id="invalid-time-for-register-session-modal"
        style={{ opacity: 1 }}
        aria-labelledby="contained-modal-title-vcenter"
      >
        <ModalHeader>
          <a
            type="button"
            className="close-button-forget"
            data-dismiss="modal"
            aria-label="Close"
            onClick={closeModalInvalidTimeForRegister}
          >
            x
          </a>
        </ModalHeader>
        <ModalPopup.Body>
          <div className="image">
            <img src={sessionTimeImage} />
          </div>
          <p className="title">
            <span>{I18n.t('session_deadline')}</span>
          </p>

          <div className="content">
            <span>{I18n.t('session_register_5h')}</span>
          </div>
        </ModalPopup.Body>
        <ModalPopup.Footer>
          <div onClick={closeModalInvalidTimeForRegister} className="btn cancel">
            {I18n.t('understand')}
          </div>
        </ModalPopup.Footer>
      </ModalPopup>

      <ModalPopup
        size="lg"
        show={visibleModalInForBuddy}
        onHide={closeModalInformationBuddy}
        id="detail-buddy-modal"
        style={{ opacity: 1 }}
        aria-labelledby="contained-modal-title-vcenter"
      >
        <ModalHeader>
          <a
            type="button"
            className="close-button-forget"
            data-dismiss="modal"
            aria-label="Close"
            onClick={closeModalInformationBuddy}
          >
            x
          </a>
        </ModalHeader>
        <ModalPopup.Body>
          <p className="title">
            <span>{I18n.t('buddy_info')}</span>
          </p>
          <div
            className="detail-description"
            dangerouslySetInnerHTML={{ __html: sessionInfo?.personalDescription }}
          ></div>
        </ModalPopup.Body>
        <ModalPopup.Footer>
          <div onClick={closeModalInformationBuddy} className="btn cancel">
            {I18n.t('confirm')}
          </div>
        </ModalPopup.Footer>
      </ModalPopup>

      <ModalPopup
        size="sm"
        show={visibleModalAcceptSession}
        onHide={closeModalAcceptSession}
        id="buddy-accept-session-modal"
        style={{ opacity: 1 }}
        aria-labelledby="contained-modal-title-vcenter"
      >
        <ModalHeader>
          <a
            type="button"
            className="close-button-forget"
            data-dismiss="modal"
            aria-label="Close"
            onClick={closeModalAcceptSession}
          >
            x
          </a>
        </ModalHeader>
        <ModalPopup.Body>
          <p className="title">
            <span>{I18n.t('confirm_session_dialog_title')}</span>
          </p>
          <p className="text-align">
            {I18n.t('confirm_session_dialog_time', { time: `${timeText} - ${onlyDateText}` })}
          </p>
          <p>{I18n.t('confirm_session_dialog_des')}</p>
          <textarea
            style={{
              resize: 'vertical',
              width: '100%',
              borderRadius: '8px',
            }}
            value={noteAcceptBuddy}
            onChange={handleValueAcceptBuddy}
            rows="4"
          ></textarea>
        </ModalPopup.Body>
        <ModalPopup.Footer>
          <div onClick={acceptByBuddy} className="btn cancel">
            {I18n.t('confirm_session_dialog_button')}
          </div>
        </ModalPopup.Footer>
      </ModalPopup>

      <ModalPopup
        size="sm"
        show={visibleModalSeniorProfile}
        id="view-profile"
        onHide={closeModalSeniorProfile}
        style={{ opacity: 1 }}
        aria-labelledby="contained-modal-title-vcenter"
      >
        <ModalHeader>
          <a
            type="button"
            className="close-button-forget"
            data-dismiss="modal"
            aria-label="Close"
            onClick={closeModalSeniorProfile}
          >
            x
          </a>
        </ModalHeader>
        <ModalPopup.Body>
          <p className="title">
            <span>{profile?.profileRole === 'senior' ? I18n.t('senior_profile') : I18n.t('buddy_profile')}</span>
          </p>
          <div className="d-flex flex-column align-items-start">
            <div className="d-flex user-card">
              <div>
                <CustomAccountLogo
                  userLabel={
                    profile?.profileRole === 'senior'
                      ? I18n.t('account_type_selection_senior')
                      : I18n.t('account_type_selection_senior_buddy')
                  }
                />
              </div>
              <div className="d-flex flex-column ml-3 user-card-title">
                <span>{profile?.name}</span>
                <span>{formatAgeAndBirthYear(profile?.dob)}</span>
              </div>
            </div>

            {renderProfileRatingSection()}

            {profile?.profileRole === 'senior' ? (
              <div className="d-flex flex-column user-card-body">
                <span className="mb-1">{I18n.t('health_characteristics')}</span>
                <ul style={{ opacity: 0.7, marginBottom: '32px', paddingLeft: '30px' }}>
                  <li>
                    {I18n.t('profile_health_note')}: {profile?.profile_health_note}
                  </li>
                  <li>
                    {I18n.t('session_health_note')}: {profile?.session_health_note}
                  </li>
                </ul>
                <span className="mb-1">{I18n.t('electronic_device_proficiency_level')}</span>
                <div style={{ opacity: 0.7, marginBottom: '32px' }} className="ml-2 d-flex flex-column">
                  <span className="mb-1">
                    <img src={phone} alt="phone" className="mr-2" />
                    {I18n.t('smartPhone')}: {profile?.smartPhone?.label}
                  </span>
                  <span className="mb-1">
                    <img src={tablet} alt="phone" className="mr-2" />
                    {I18n.t('tablet')}: {profile?.tablet?.label}
                  </span>
                  <span>
                    <img src={laptop} alt="phone" className="mr-2" />
                    {I18n.t('laptop')}: {profile?.laptop?.label}
                  </span>
                </div>
                {profile?.favoritesCategories?.length > 0 ? (
                  <>
                    <span className="mb-2">{I18n.t('senior_favorite_categories')}</span>
                    <div className="user-card-card mb-5">
                      {profile?.favoritesCategories.map((item, index) => (
                        <div key={index}>{item?.name}</div>
                      ))}
                    </div>
                  </>
                ) : null}
              </div>
            ) : (
              <div className="d-flex flex-column user-card-body">
                {profile?.workingInformation ? (
                  <>
                    <span className="mb-1">{I18n.t('buddy_work')}</span>
                    <ul style={{ opacity: 0.7, marginBottom: '32px', paddingLeft: '30px' }}>
                      <li>{profile?.workingInformation}</li>
                    </ul>
                  </>
                ) : null}
                {profile?.sharingCategories?.length > 0 ? (
                  <>
                    <span className="mb-2">{I18n.t('buddy_share_categories')}</span>
                    <div className="user-card-card mb-5">
                      {profile?.sharingCategories.map((item, index) => (
                        <div key={index}>{item?.name}</div>
                      ))}
                    </div>
                  </>
                ) : null}
                <span className="mb-1">{I18n.t('buddy_achievements')}</span>
                <ul style={{ opacity: 0.7, marginBottom: '32px', paddingLeft: '30px' }}>
                  {profile?.rewards?.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
                <span className="mb-1">{I18n.t('buddy_experience')}</span>
                <ul style={{ opacity: 0.7, marginBottom: '32px', paddingLeft: '30px' }}>
                  {profile?.experiences?.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
                <span className="mb-1">{I18n.t('buddy_solutions')}</span>
                <ul style={{ opacity: 0.7, marginBottom: '32px', paddingLeft: '30px' }}>
                  {profile?.solutions?.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
                <span className="mb-1">{I18n.t('buddy_highlights')}</span>
                <ul style={{ opacity: 0.7, marginBottom: '32px', paddingLeft: '30px' }}>
                  {profile?.highLights?.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>
            )}

            <div
              className="report-user"
              style={{
                padding: '8px',
                backgroundColor: '#4B5563',
                borderRadius: '8px',
                width: '100%',
                marginBottom: '10px',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <span style={{ color: '#D1D5DB', fontSize: '14px', fontWeight: 400 }}>
                  {I18n.t('incorrect_information')}
                </span>
                <a
                  onClick={() =>
                    handleReport(
                      profile?.profileRole === 'senior' ? 'explorer' : 'guide',
                      profile?.profileRole === 'senior'
                        ? sessionInfo?.seniorRegisted?._id
                        : sessionInfo?.infoAuthor?._id,
                    )
                  }
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    color: '#D1D5DB',
                    fontSize: '14px',
                    fontWeight: 500,
                    cursor: 'pointer',
                  }}
                >
                  <img src={report} alt="report" style={{ width: '16px', height: '16px' }} />
                  {I18n.t('report')}
                </a>
              </div>
            </div>
          </div>
        </ModalPopup.Body>
        <ModalPopup.Footer>
          <div onClick={closeModalSeniorProfile} className="btn success">
            {I18n.t('viewed')}
          </div>
        </ModalPopup.Footer>
      </ModalPopup>

      <ModalPopup
        size="sm"
        show={visibleModalRejectSession}
        onHide={closeModalRejectSession}
        id="buddy-reject-session-modal"
        style={{ opacity: 1 }}
        aria-labelledby="contained-modal-title-vcenter"
      >
        <ModalHeader>
          <a
            type="button"
            className="close-button-forget"
            data-dismiss="modal"
            aria-label="Close"
            onClick={closeModalRejectSession}
          >
            x
          </a>
        </ModalHeader>
        <ModalPopup.Body>
          <p className="title">
            <span>{I18n.t('reject_session_dialog_title')}</span>
          </p>
          <p className="text-align">
            {I18n.t('reject_session_dialog_time', { time: `${timeText} - ${onlyDateText}` })}
          </p>
          <p>{I18n.t('reject_session_dialog_des')}</p>
          <textarea
            style={{
              resize: 'vertical',
              width: '100%',
              borderRadius: '8px',
            }}
            value={noteAcceptBuddy}
            onChange={handleValueAcceptBuddy}
            rows="4"
          ></textarea>
        </ModalPopup.Body>
        <ModalPopup.Footer>
          <div onClick={rejectByBuddy} className="btn cancel">
            {I18n.t('reject_session_dialog_button')}
          </div>
        </ModalPopup.Footer>
      </ModalPopup>

      <ModalPopup
        size="sm"
        show={visibleModalWaitingConfirm}
        onHide={closeWaitingConfirmModal}
        id="waiting-confirm-session-modal"
        style={{ opacity: 1 }}
        aria-labelledby="contained-modal-title-vcenter"
      >
        <ModalHeader>
          <a
            type="button"
            className="close-button-forget"
            data-dismiss="modal"
            aria-label="Close"
            onClick={closeWaitingConfirmModal}
          >
            x
          </a>
        </ModalHeader>
        <ModalPopup.Body>
          <div className="image">
            <img src={sessionTimeImage} />
          </div>
          <p className="title">{I18n.t('awaiting_buddy_join')}</p>

          <div className="content">{I18n.t('buddy_join_tecd_noti')}</div>
        </ModalPopup.Body>
        <ModalPopup.Footer>
          <div onClick={closeWaitingConfirmModal} className="btn cancel">
            {I18n.t('understand')}
          </div>
        </ModalPopup.Footer>
      </ModalPopup>

      <ModalPopup
        size="sm"
        show={visibleModalReport}
        onHide={closeModalReport}
        id="report-modal"
        style={{ opacity: 1 }}
        aria-labelledby="contained-modal-title-vcenter"
        scrollable
      >
        <ModalHeader>
          <a
            type="button"
            className="close-button-forget"
            data-dismiss="modal"
            aria-label="Close"
            onClick={closeModalReport}
          >
            x
          </a>
        </ModalHeader>
        <ModalPopup.Body>
          <p className="title">
            <span>{I18n.t('report_violation_title')}</span>
          </p>
          <div className="content">
            <span>{I18n.t('report_violation_description')}</span>
          </div>

          {/* Report Reasons */}
          <div style={{ marginBottom: '24px' }}>
            <p style={{ marginBottom: '12px', fontSize: '16px', fontWeight: 400 }}>{I18n.t('report_select_reason')}</p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
              {filteredReportReasons.map((reason) => (
                <button
                  key={reason.key}
                  onClick={() => handleReportReasonChange(reason.key)}
                  style={{
                    padding: '8px 16px',
                    borderRadius: '24px',
                    border: `1.5px solid ${reportReason.includes(reason.key) ? '#F59E0B' : '#E5E7EB'}`,
                    backgroundColor: reportReason.includes(reason.key) ? '#FEF3C7' : '#FFFFFF',
                    color: reportReason.includes(reason.key) ? '#F59E0B' : '#4B5563',
                    fontSize: '14px',
                    fontWeight: 400,
                    cursor: 'pointer',
                    transition: 'all 0.2s',
                  }}
                >
                  {reason.label}
                </button>
              ))}
            </div>
          </div>

          {/* Description */}
          {reportReason.length > 0 && (
            <div style={{ marginBottom: '16px' }}>
              <p style={{ marginBottom: '8px', fontSize: '16px', fontWeight: 400 }}>
                {I18n.t('report_detailed_description')}
              </p>
              <textarea
                value={reportDescription}
                onChange={handleReportDescriptionChange}
                placeholder="..."
                style={{
                  width: '100%',
                  minHeight: '120px',
                  padding: '12px',
                  borderRadius: '8px',
                  border: '1px solid #EEEFF2',
                  backgroundColor: '#EEEFF2',
                  color: '##111827',
                  fontSize: '14px',
                  lineHeight: '1.5',
                  resize: 'vertical',
                  fontFamily: 'inherit',
                }}
              />
              <div style={{ textAlign: 'right', marginTop: '8px', fontSize: '14px', color: '#9CA3AF' }}>
                {reportDescription.length}/500
              </div>
            </div>
          )}
        </ModalPopup.Body>
        <ModalPopup.Footer>
          <div style={{ display: 'flex', gap: '12px', width: '100%' }}>
            <button onClick={closeModalReport} className="btn-report-cancel">
              {I18n.t('cancel_button')}
            </button>
            <button
              onClick={submitReport}
              disabled={reportReason.length === 0 || isSubmittingReport}
              className={`btn-report-submit ${reportReason.length === 0 || isSubmittingReport ? 'disabled' : ''}`}
              style={{
                cursor: isSubmittingReport ? 'not-allowed' : 'pointer',
                opacity: isSubmittingReport ? 0.6 : 1,
              }}
            >
              {I18n.t('submit_report_button')}
            </button>
          </div>
        </ModalPopup.Footer>
      </ModalPopup>

      <UsersRatingListModal
        visible={showUserRatingModal}
        sessionId={sessionId}
        userId={isMvpUserGuide(user) ? sessionInfo?.seniorRegisted?._id : sessionInfo?.infoAuthor?._id}
        user={user}
        onClose={() => setShowUserRatingModal(false)}
      />

      <TopicRatingListModal
        visible={showTopicRatingModal}
        topicId={sessionInfo?.topicId}
        onClose={() => setShowTopicRatingModal(false)}
        totalScore={sessionInfo?.dataRatingTopic?.totalPointEvaluating}
        totalCount={sessionInfo?.dataRatingTopic?.totalEvaluating}
        user={user}
      />
    </div>
  );
}

const mapStateToProps = ({ user, mvp }) => ({
  user,
  mvp,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getDetailSession,
      getDetailTopic,
      getListBuddyRole,
      removeSession,
      trackingSession,
      buddyAcceptOrRejectSession,
      getProfileRoleBySession,
      verifyJoinSession,
      reportData,
      getReasonReport,
      updatePageStatus,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(DetailSession);
